import { Pipe, PipeTransform } from '@angular/core';
import { TreeNodeOperation } from './tree.types';

@Pipe({
  name: 'treeOperationFilter'
})
export class TreeOperationFilterPipe implements PipeTransform {
  transform(items: TreeNodeOperation[], args: string[]): TreeNodeOperation[] {
    if (args && args.length > 0) {
      return items.filter(item => args.indexOf(item.id) >= 0);
    } else {
      return items;
    }
  }
}
